import React, { useEffect, useState } from 'react'
import { Box, IconButton, Typography } from '@material-ui/core'
import { useStyles } from './styles'
import {
    mdiPencilOutline,
    mdiRefresh,
    mdiInformationOutline,
    mdiTools
} from '@mdi/js'
import { Battery } from 'web/src/app/root/components/common'
import { DeviceNameAndBatteryModal } from './device-name-and-battery-modal'
// import { IconButton } from 'web/src/app/root/components/common'
import Icon from '@mdi/react'
import { useSelector } from 'react-redux'
import useTimer from 'web/src/app/root/hooks/use-timer'
import { Time } from 'web/src/app/root/hooks/use-timer/time'
import { getLocalTimestampFromDbDate } from 'web/src/utils'
import { InfoIcon, PencilIcon, RefreshCcwIcon } from 'lucide-react'

export const DeviceNameAndBattery = ({
    batteryPercentage,
    device,
    setIsConfirmModal,
    setIsBatteryModalOpen,
    permissions,
    isTom,
    isJerryLora,
    isJerryBaitRat
}) => {
    const { locale } = useSelector(state => state.main)
    const classes = useStyles()
    const [isModalOpen, setIsModalOpen] = useState(false)

    const { totalSeconds, isRunning, restart, stop } = useTimer({
        expiryTimestamp: device.maintenance_mode_ends_at
            ? getLocalTimestampFromDbDate(device.maintenance_mode_ends_at)
            : new Date(),
        onExpire: () => console.log('m mode expired!'),
        autoStart: false
    })

    useEffect(() => {
        if (
            device.in_maintenance_mode &&
            device.maintenance_mode_ends_at &&
            getLocalTimestampFromDbDate(device.maintenance_mode_ends_at) >
                new Date()
        ) {
            restart(
                getLocalTimestampFromDbDate(device.maintenance_mode_ends_at)
            )
        } else {
            stop()
        }
    }, [device.maintenance_mode_ends_at, device.in_maintenance_mode])

    return (
        <Box className={classes.deviceNameAndBatteryWrapper}>
            <Box className={classes.deviceNameWrapper}>
                <Typography className={classes.deviceName}>
                    {device.name}
                </Typography>

                <IconButton onClick={() => setIsModalOpen(true)}>
                    {permissions.updateDevice ? (
                        <PencilIcon size={18} />
                    ) : (
                        <InfoIcon size={18} />
                    )}
                </IconButton>
            </Box>
            {isModalOpen && (
                <DeviceNameAndBatteryModal
                    setIsConfirmModal={setIsConfirmModal}
                    setIsBatteryModalOpen={setIsBatteryModalOpen}
                    isModalOpen={isModalOpen}
                    setIsModalOpen={setIsModalOpen}
                />
            )}

            <Typography className={classes.deviceLocation}>
                {device.description}
            </Typography>
            <Box className={classes.batteryStatusWrapper}>
                <Battery value={device.battery_status} />
                <Typography>{batteryPercentage}</Typography>

                {permissions.updateDevice &&
                    !isTom &&
                    !isJerryLora &&
                    !isJerryBaitRat &&
                    device.pcb_revision === 'EU-J103' && (
                        <IconButton onClick={() => setIsBatteryModalOpen(true)}>
                            <RefreshCcwIcon size={18} />
                        </IconButton>
                    )}
            </Box>
            {device.in_maintenance_mode ? (
                <div
                    style={{
                        marginTop: 4,
                        display: 'flex',
                        alignItems: 'center'
                    }}>
                    <Icon path={mdiTools} size={1} style={{ marginRight: 4 }} />
                    {isRunning && totalSeconds > 0 ? (
                        Time.getCountdownLabel(totalSeconds)
                    ) : (
                        <div>{locale.common.exitingMMode}</div>
                    )}
                </div>
            ) : null}
        </Box>
    )
}
